export type NavItem = {
  label: string
  href: string
  description: string
  badge?: string
  children?: { label: string; href: string; description: string }[]
}

export const productGroups: { heading: string; items: NavItem[] }[] = [
  {
    heading: 'Systems',
    items: [
      {
        label: 'Noetivra',
        href: '/noetivra',
        badge: 'Coming soon',
        description: 'Interactive workspace for knowledge, assessments & collaboration',
      },
      {
        label: 'Semantic Knowledge Platform',
        href: '/semantic-knowledge',
        description: 'Connected knowledge, semantic search & AI',
      },
    ],
  },
  {
    heading: 'Frameworks',
    items: [
      {
        label: 'Human Capability Framework',
        href: '/human-capability',
        description: 'Assessment, development & readiness',
        children: [
          { label: 'CJI', href: '/cji', description: 'Civic Judgment Index · reasoning & judgment' },
          { label: 'NCJI', href: '/ncji', description: 'Neurocognitive Civic Judgment Index · capability & development' },
        ],
      },
    ],
  },
]

export const companyLinks = [
  { label: 'About', href: '/about', description: 'Mission & Vision' },
  { label: 'Research', href: '/research', description: 'Scientific foundations & research agenda' },
  { label: 'Roadmap', href: '/roadmap', description: 'Product development & planned capabilities' },
  { label: 'Partnerships', href: '/partnerships', description: 'Collaborate with Us' },
  { label: 'Investors', href: '/investors', description: 'The opportunity & business model' },
]

export const footerColumns = [
  {
    heading: 'Systems',
    links: [
      { label: 'Noetivra · Coming soon', href: '/noetivra', nested: false },
      { label: 'Semantic Knowledge Platform', href: '/semantic-knowledge', nested: false },
    ],
  },
  {
    heading: 'Frameworks',
    links: [
      { label: 'Human Capability Framework', href: '/human-capability', nested: false },
      { label: 'CJI', href: '/cji', nested: true },
      { label: 'NCJI', href: '/ncji', nested: true },
    ],
  },
  {
    heading: 'Solutions',
    links: [
      { label: 'Research', href: '/solutions#scientific-research', nested: false },
      { label: 'Education', href: '/education', nested: false },
      { label: 'Employers', href: '/employers', nested: false },
      { label: 'Clinical', href: '/noetivra#clinical', nested: false },
      { label: 'Civil Society', href: '/civil-society', nested: false },
      { label: 'Government', href: '/government', nested: false },
      { label: 'Leadership', href: '/leadership', nested: false },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'About', href: '/about', nested: false },
      { label: 'Research', href: '/research', nested: false },
      { label: 'Roadmap', href: '/roadmap', nested: false },
      { label: 'Partnerships', href: '/partnerships', nested: false },
      { label: 'Investors', href: '/investors', nested: false },
      { label: 'Contact', href: '/contact', nested: false },
    ],
  },
]
